exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkdetails-selects{display:flex}.react-select.checkdetails-select{flex:1}.react-select.checkdetails-select-levels{flex:0.3}", ""]);

// exports
